// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InnerInstruction } from './InnerInstruction';
import {
    InnerInstructionFromJSON,
    InnerInstructionFromJSONTyped,
    InnerInstructionToJSON,
} from './InnerInstruction';

/**
 * 
 * @export
 * @interface Instruction
 */
export interface Instruction {
    /**
     * 
     * @type {Array<InnerInstruction>}
     * @memberof Instruction
     */
    innerInstructions: Array<InnerInstruction>;
    /**
     * 
     * @type {string}
     * @memberof Instruction
     */
    programId: string;
    /**
     * 
     * @type {string}
     * @memberof Instruction
     */
    data: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Instruction
     */
    accounts: Array<string>;
}

/**
 * Check if a given object implements the Instruction interface.
 */
export function instanceOfInstruction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "innerInstructions" in value;
    isInstance = isInstance && "programId" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "accounts" in value;

    return isInstance;
}

export function InstructionFromJSON(json: any): Instruction {
    return InstructionFromJSONTyped(json, false);
}

export function InstructionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Instruction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'innerInstructions': ((json['innerInstructions'] as Array<any>).map(InnerInstructionFromJSON)),
        'programId': json['programId'],
        'data': json['data'],
        'accounts': json['accounts'],
    };
}

export function InstructionToJSON(value?: Instruction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'innerInstructions': ((value.innerInstructions as Array<any>).map(InnerInstructionToJSON)),
        'programId': value.programId,
        'data': value.data,
        'accounts': value.accounts,
    };
}

